import { useEffect, useState } from 'react'
import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'
import { Box, useMediaQuery } from '@mui/material'

import { RowBox } from '@components/shared/RowBox'
import { Input } from '@components/shared/Input'
import { BaseModal } from '@components/modals/BaseModal'
import { EditIcon } from '@assets/svgs/EditIcon'
import { Button } from '@components/shared/Button'
import { emotionTheme } from '@styles/theme'
import { initialFormValues } from './form/initialFormValues'
import { setInitialValues } from './helpers/setInitialValues'
import { ReturnModal } from '@components/modals/ReturnModal'
import { WarningIcon } from '@assets/svgs/WarningIcon'
import { PlusCircleIcon } from '@assets/svgs/PlusCircleIcon'

import type { AddEditNotFeedModalProps } from './types'

import * as S from './styles'

export const AddEditNotFeed = ({ data, open, onClose, ...rest }: AddEditNotFeedModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  const methods = useForm<any>({
    defaultValues: initialFormValues
    // resolver: editBonusModalSchema
  })

  const { handleSubmit, reset } = methods

  const [openCancelDetailedSummaryModal, setOpenCancelDetailedSummaryModal] = useState(false)

  const onError = (errors: FieldErrors<any>) => console.log({ errors })

  const onSubmit = (formData: any) => console.log({ formData })

  const isEdit = !!data

  useEffect(() => {
    !!data && reset(setInitialValues(data!))
  }, [data])

  useEffect(() => {
    !open && methods.reset(initialFormValues)
  }, [open])

  return (
    <>
      <BaseModal
        width={870}
        open={open}
        heightContainer={isMobile ? '100%' : 'auto'}
        title={isEdit ? 'Editar Item Não Alimentar' : 'Adicionar um Item'}
        headerIcon={isEdit ? <EditIcon /> : <PlusCircleIcon />}
        onClose={() => setOpenCancelDetailedSummaryModal(true)}
        {...rest}
      >
        <S.Title>Preencha todos os campos adicionar um novo item.</S.Title>

        {isEdit && (
          <S.Warning>Atenção: Ao confirmar esta edição, todos os dados do item anterior serão excluídos.</S.Warning>
        )}

        <FormProvider {...methods}>
          <S.Form onSubmit={handleSubmit(onSubmit, onError)}>
            <RowBox columns={4}>
              <Input name="category" label="Categoria" placeholder="Informe uma categ." required />
              <Input name="description" label="Descrição" placeholder="Informe uma descr." required />
              <Input name="unit" label="Unidade" placeholder="Informe uma unid." required />
              <Input name="quantity" label="Quantidade" placeholder="Informe uma qtd." required />
            </RowBox>

            <RowBox columns={2}>
              <Input name="unitValue" label="Valor Unitário" placeholder="R$ 0,00" maskType="currency" required />
              <Input
                name="totalValue"
                label="Valor Total"
                placeholder="R$ 0,00"
                maskType="currency"
                disabled
                isIcon={false}
              />
            </RowBox>

            <RowBox columns={2} marginTop={16}>
              <Box />

              <RowBox columns={2}>
                <Button width="100%" colorType="outlineBlue" onClick={() => setOpenCancelDetailedSummaryModal(true)}>
                  Cancelar
                </Button>
                <Button width="100%" type="submit" colorType="solidBlue">
                  Salvar
                </Button>
              </RowBox>
            </RowBox>
          </S.Form>
        </FormProvider>
      </BaseModal>

      <ReturnModal
        open={openCancelDetailedSummaryModal}
        headerIcon={<WarningIcon />}
        title="Deseja realmente cancelar a ação?"
        message="Todo o seu progresso será perdido!"
        headerTitle="Você tem certeza?"
        cancelButtonText="Cancelar"
        confirmButtonText="Confirmar"
        onClose={setOpenCancelDetailedSummaryModal}
        onConfirm={() => {
          onClose(false)
          setOpenCancelDetailedSummaryModal(false)
        }}
      />
    </>
  )
}
